export const BackgroundCarouselTestIds = {
  CAROUSEL: 'login.background-carousel',
};
